var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcCameraOverlayStairs = function SvgIcCameraOverlayStairs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 230.6,
    height: 150.9,
    fill: "none",
    viewBox: "0 0 230.6 150.9"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0.2,
    d: "m163.89 1 32.82 17.13-162.89 86.43L1 87.44Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0.4,
    d: "M196.71 18.13v14.06L33.82 118.63v-14.07Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0.2,
    d: "m196.71 32.19 32.83 17.13-162.89 86.44-32.83-17.13Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0.4,
    d: "M229.54 49.32v14.06L66.65 149.82v-14.06Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0.5,
    d: "M33.82 104.56 1 87.44v28.13l65.65 34.25v-14.06l-32.83-17.13Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeDasharray: "4 4",
    strokeOpacity: 0.9,
    strokeWidth: 2,
    d: "m163.89 1 32.82 17.13v14.06l32.83 17.13v14.06L66.65 149.82 1 115.57V87.44Zm32.82 17.13L33.82 104.56v14.07l162.89-86.44M33.82 104.56 1 87.44m228.54-38.12L66.65 135.76v14.06m0-14.06-32.83-17.13"
  })));
};
export default SvgIcCameraOverlayStairs;